import { render, staticRenderFns } from "./AddNewPayMeth.vue?vue&type=template&id=fbaaf6fc&scoped=true&"
import script from "./AddNewPayMeth.vue?vue&type=script&lang=js&"
export * from "./AddNewPayMeth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaaf6fc",
  null
  
)

export default component.exports